export default "__VITE_ASSET__Cddwan6t__"